import {
    DEALERDSRTRANSACTIONEXCELPDFFILE_FAILED,
    DEALERDSRTRANSACTIONEXCELPDFFILE_SUCCESS,
    RESET_DEALERDSRTRANSACTIONEXCELPDFFILE,
    LOADING_DEALERDSRTRANSACTIONEXCELPDFFILE,
    NETWORK_ERROR_DEALERDSRTRANSACTIONEXCELPDFFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";

const resetDealerDsrTransactionExcelPdfFileList = () => {
    return { type: RESET_DEALERDSRTRANSACTIONEXCELPDFFILE };
};


const dealerDsrTransactionExcelPdfFiles = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERDSRTRANSACTIONEXCELPDFFILE });
    await dealerServices
        .post("dsrtransactionExcelPdfFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerDsrTransactionExcelPdfFilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerDsrTransactionExcelPdfFileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERDSRTRANSACTIONEXCELPDFFILE,
                payload: err
            });
        });
};

function dealerDsrTransactionExcelPdfFilesuccess(data) {
    return {
        type: DEALERDSRTRANSACTIONEXCELPDFFILE_SUCCESS,
        payload: data
    };
}
function dealerDsrTransactionExcelPdfFileFailed(data) {
    return {
        type: DEALERDSRTRANSACTIONEXCELPDFFILE_FAILED,
        payload: data
    };
}


export { resetDealerDsrTransactionExcelPdfFileList, dealerDsrTransactionExcelPdfFiles }